<script setup>
import {ref, reactive, computed, onBeforeMount, nextTick} from 'vue';
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import router from "@/router/index.js";
import YTEditor from "@/components/YTEditor/index.vue";
import {listAdvertisementPosition} from "@/api/advertisementPosition/advertisementPosition.js";
import moment from "moment"

const props = defineProps({
  // 加载状态
  loading: {
    type: Boolean,
    default: false
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  isAudit: {
    type: Boolean,
    default: false,
  },
  listAdvLog: {
    type: Array,
    default: []
  }
})

onBeforeMount(async () => {
  await handleGetAdvertisementPosition()
  if (props.isAudit || props.readOnly) {
    rules.value = rulesThree
  }
})

const cacheSaleLocationData = reactive({
  width: 0,
  height: 0,
  image: null
})
// 获取上架位置
const handleGetAdvertisementPosition = async () => {
  try {
    loadingValue.value = true
    let param = {
      page: 1,
      pageSize: 100,
    }
    const res = await listAdvertisementPosition(param)
    saleLocationEnum.value = res.list
    ruleForm.positionName = handleReviewSaleLocation(ruleForm.positionId)
    loadingValue.value = false
  } catch (e) {
    console.log(e)
    loadingValue.value = false
  }
}
// 处理上架位置改变
const handlePositionChange = (e) => {
  const target = saleLocationEnum.value.find(i => i.positionId === e)
  cacheSaleLocationData.width = target?.imageWidth
  cacheSaleLocationData.height = target?.imageHeight
  cacheSaleLocationData.image = target?.image
}

const emit = defineEmits(['submit', 'update:loading', 'audit']);

const loadingValue = computed({
  get: () => props.loading,
  set: (val) => emit('update:loading', val)
})

// 上架位置枚举
const saleLocationEnum = ref([])
// 上架轮播图位置枚举
const saleLocationNumEnum = [
  {
    sort: 0,
    sortName: "默认"
  },
  {
    sort: 1,
    sortName: "轮播图1号位"
  },
  {
    sort: 2,
    sortName: "轮播图2号位"
  },
  {
    sort: 3,
    sortName: "轮播图3号位"
  },
  {
    sort: 4,
    sortName: "轮播图4号位"
  },
  {
    sort: 5,
    sortName: "轮播图5号位"
  },
  {
    sort: 6,
    sortName: "轮播图6号位"
  },
]

// 时间单位枚举
const timeEnum = [
  {
    label: "天",
    value: "DAY"
  },
  {
    label: "月",
    value: "MONTH"
  },
  {
    label: "年",
    value: "YEAR"
  },
]

// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  advertisementId: null,
  advertisementName: null,
  advertisementNameEn: "Coming Soon ...",
  advertisementType: "BANNER",
  positionId: null,
  positionName: null,
  sort: null,
  sortName: null,
  onlineTime: null,
  offlineTime: null,
  effectiveValue: null,
  effectiveType: null,
  effectiveTypeLabel: null,
  coverImage: null,
  details: null,
  details_en: null,
  detailsImages: [],
  detailsEnImages: [],
  urlType: null,
  url: null,
  urlAppId: null,
  remark: null
})
// 广告名称校验规则
const checkAdvertisementName = (rule, value, callback) => {
  if (!ruleForm.advertisementName) {
    return callback(new Error("请输入广告名称（中文）"))
  }
  if (!ruleForm.advertisementNameEn) {
    return callback(new Error("请输入广告名称（English）"))
  }
  return callback()
}
// 上传位置校验规则
const checkPositionId = (rule, value, callback) => {
  if (!ruleForm.positionId) {
    return callback(new Error("请选择上传位置页面"))
  }
  if (!ruleForm.sort && ruleForm.sort !== 0) {
    return callback(new Error("请选择上传位置轮播图排序"))
  }
  return callback()
}
// 跳转链接校验规则
const checkUrlType = (rule, value, callback) => {
  if (!props.readOnly && ruleForm.urlType) {
    if (ruleForm.urlType === 'INNER' && !ruleForm.url) return callback(new Error("请填写内部跳转链接"))
    if (ruleForm.urlType === 'OUTER') {
      // if (!ruleForm.url) {
      //   return callback(new Error("请填写外部跳转链接"))
      // }
      if (!ruleForm.urlAppId) {
        return callback(new Error("请填写外部跳转小程序AppId"))
      }
    }
  }
  return callback()
}
// 默认校验规则
const rulesOne = {
  advertisementName: [
    {required: true, validator: checkAdvertisementName, trigger: 'blur'},
  ],
  positionId: [
    {required: true, validator: checkPositionId, trigger: 'blur'},
  ],
  onlineTime: [
    {required: true, message: "请选择上架时间", trigger: 'change'},
  ],
  offlineTime: [
    {required: true, message: "请选择下架时间", trigger: 'change'},
  ],
  coverImage: [
    {required: true, message: "请上传封面Banner图片", trigger: 'change'},
  ],
  urlType: [
    {validator: checkUrlType, trigger: 'change'},
  ]
}
// 广告是默认广告时校验规则
const rulesTow = {
  advertisementName: [
    {required: true, validator: checkAdvertisementName, trigger: 'blur'},
  ],
  positionId: [
    {required: true, validator: checkPositionId, trigger: 'blur'},
  ],
  coverImage: [
    {required: true, message: "请上传封面Banner图片", trigger: 'change'},
  ]
}
// 审批时的校验规则
const rulesThree = {

}
// 表单校验规则
const rules = ref(rulesOne)

// 上传组件锚点
const boxUploadRef = ref()
// 处理图片上传成功
const handlePicSuccess = (url) => {
  console.log("url", url[0])
  ruleForm.coverImage = null
  ruleForm.coverImage = url[0]
  loadingValue.value = false
  ruleFormRef.value.validateField("coverImage")
}
// 处理删除图片
const handlePicRemove = (url) => {
  ruleForm.coverImage = url.length > 0 ? url[0] : null
  ruleFormRef.value.validateField("coverImage")
}
// 清空表单信息
const resetForm = () => {
  router.back()
}
// 表单校验
const submit = async () => {
  loadingValue.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      // 处理广告页面详情图
      const res = await handleRich2Form()
      if (!res) throw new Errow("商品描述（中文）富文本描述过长")
      const res2 = await handleRich2FormEn()
      if (!res2) throw new Errow("商品描述（English）富文本描述过长")
      ruleForm.detailsImages = YTEditorRef.value.getImagesUrlArr()
      ruleForm.detailsEnImages = YTEditorEnRef.value.getImagesUrlArr()
      console.log("ruleForm", ruleForm)
      emit('submit', ruleForm)
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loadingValue.value = false
    }
  })
}
// 处理审核操作
const handleAudit = async (type) => {
  loadingValue.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      let param = {
        advertisementId: ruleForm.advertisementId,
        reviewState: type === "approved" ? "APPROVED" : "REJECTED",
        remark: ruleForm.remark,
      }
      emit('audit', param)
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loadingValue.value = false
    }
  })
}
// 处理表单回显
const handleReview = (info) => {
  console.log("run in handleReview info", info)
  Object.assign(ruleForm, info)
  if (props.isEdit) {
    // 回显图片尺寸
    handlePositionChange(ruleForm.positionId)
    // 回显封面Banner图片
    boxUploadRef.value.handleReview([info.coverImage])
  }
  if (props.readOnly) {
    console.log("run in if===")
    ruleForm.positionName = handleReviewSaleLocation(ruleForm.positionId)
    console.log("saleLocationEnum.value", saleLocationEnum.value)
    console.log("ruleForm.positionId", ruleForm.positionId)
    console.log("ruleForm.positionName", ruleForm.positionName)
    ruleForm.sortName = handleReviewSaleNumLocation(ruleForm.sort)
    ruleForm.effectiveTypeLabel = handleReviewEffectiveType(ruleForm.effectiveType)
  }
  if (ruleForm.isDefault) {
    rules.value = rulesTow
  }
}
// 处理上架位置反显
const handleReviewSaleLocation = (id) => {
  const target = saleLocationEnum.value.find(i => i.positionId === id)
  return target?.positionName
}
// 处理上架轮播图位置反显
const handleReviewSaleNumLocation = (id) => {
  const target = saleLocationNumEnum.find(i => i.sort === id)
  return target?.sortName
}
// 处理广告有效期单位反显
const handleReviewEffectiveType = (id) => {
  const target = timeEnum.find(i => i.value === id)
  return target?.label
}
// 广告详情页中文锚点
const YTEditorRef = ref()
// 广告详情页英文锚点
const YTEditorEnRef = ref()
// 处理广告详情页面（中文）富文本赋值给表单
const handleRich2Form = async () => {
  console.log("赋值结果", YTEditorRef.value.getTxtTooLongState())
  if (YTEditorRef.value.getTxtTooLongState()) {
    ElMessage.error("广告详情页面（中文）内容过长，描述内容请按规定照字数编写。")
    return false
  }
  ruleForm.details = YTEditorRef.value.getTxt()
  return true
}
// 处理广告详情页面（English）富文本赋值给表单
const handleRich2FormEn = async () => {
  console.log("赋值结果", YTEditorEnRef.value.getTxtTooLongState())
  if (YTEditorEnRef.value.getTxtTooLongState()) {
    ElMessage.error("广告详情页面（English）内容过长，描述内容请按规定照字数编写。")
    return false
  }
  ruleForm.details_en = YTEditorEnRef.value.getTxt()
  return true
}

// 处理上架时间/广告有效期单位选择/下架时间后自动填写
const handleEffectiveValue = () => {
  if (!ruleForm.onlineTime || !ruleForm.offlineTime || !ruleForm.effectiveType) return

  const start = moment(ruleForm.onlineTime)
  const end = moment(ruleForm.offlineTime)

  let diff = 0;
  switch (ruleForm.effectiveType) {
    case "YEAR":
      diff = end.diff(start, "years", true)
      break;
    case "MONTH":
      diff = end.diff(start, "months", true)
      break;
    case "DAY":
      diff = end.diff(start, "days", true)
      break;
    default:
      diff = 0;
  }

  ruleForm.effectiveValue = diff.toFixed(2)
}
// 处理上传位置选择轮播图位置
const handleSelectSort = () => {
  ruleFormRef.value.validateField("positionId")
}

/*中英文切换输入框相关Tab*/
// 广告名称tab
const advTab = ref("zh")
// 广告详情tab
const advDetailTab = ref("zh")

defineExpose({
  handleReview
})
</script>

<template>
  <el-form
      ref="ruleFormRef"
      style="max-width: 100%"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm"
      status-icon
      size="large"
      v-loading="loadingValue"
  >
    <el-form-item label="广告名称：" prop="advertisementName">
      <div v-if="props.readOnly">
        {{ruleForm.advertisementName}}({{ruleForm.advertisementNameEn}})
      </div>
      <el-tabs
          v-model="advTab"
          type="card"
          class="demo-tabs"
          v-else
      >
        <el-tab-pane label="中文" name="zh">
          <el-input style="width: 498px;" show-word-limit v-model="ruleForm.advertisementName" maxlength="30" placeholder="广告名称最长30个字" />
        </el-tab-pane>
        <el-tab-pane label="English" name="en">
          <el-input style="width: 498px;" show-word-limit v-model="ruleForm.advertisementNameEn" maxlength="90" placeholder="The name of a advertisement should be up to 90 characters long" />
        </el-tab-pane>
      </el-tabs>
    </el-form-item>
    <el-form-item label="广告类型：">
      <span v-if="ruleForm.advertisementType === 'BANNER'">Banner广告</span>
      <span v-else>未知类型</span>
    </el-form-item>
    <el-form-item label="上传位置：" prop="positionId">
      <div v-if="props.readOnly">
        {{ruleForm.positionName}} - {{ruleForm.sortName}}
      </div>
      <div v-else>
        <div style="flex: 1;" class="mg_b_1">
          <el-select class="mg_r_1" v-model="ruleForm.positionId" placeholder="请选择页面" style="width: 240px" @change="handlePositionChange">
            <el-option
                v-for="item in saleLocationEnum"
                :key="item.positionId"
                :label="item.positionName"
                :value="item.positionId"
            />
          </el-select>
          <el-select @change="handleSelectSort" :disabled="!ruleForm.positionId" v-model="ruleForm.sort" placeholder="请选择第几位" style="width: 240px">
            <el-option
                v-for="item in saleLocationNumEnum"
                :key="item.sort"
                :label="item.sortName"
                :value="item.sort"
            />
          </el-select>
        </div>
        <div class="flex_left" style="flex: 1">
          <el-image
              v-if="cacheSaleLocationData.image"
              style="width: 150px; height: 150px"
              :src="cacheSaleLocationData.image"
              :zoom-rate="1.2"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="[cacheSaleLocationData.image]"
              show-progress
              :initial-index="0"
              fit="contain"
          />
        </div>
      </div>
    </el-form-item>
    <el-form-item label="上架时间：" prop="onlineTime">
      <div v-if="props.readOnly">
        {{ruleForm.onlineTime}}
      </div>
      <el-date-picker
          :disabled="ruleForm.isDefault"
          @change="handleEffectiveValue"
          v-else
          class="mg_r_1"
          v-model="ruleForm.onlineTime"
          type="datetime"
          placeholder="上架时间"
      />
    </el-form-item>
    <el-form-item label="广告有效期：">
      <div v-if="props.readOnly">
        {{ruleForm.effectiveValue}}{{ruleForm.effectiveTypeLabel}}
      </div>
      <div v-else>
        <el-input-number :disabled="ruleForm.isDefault" class="mg_r_1" v-model="ruleForm.effectiveValue" placeholder="请输入有效期"/>
        <el-select :disabled="ruleForm.isDefault" @change="handleEffectiveValue" v-model="ruleForm.effectiveType" placeholder="选择时间单位" style="width: 140px">
          <el-option
              v-for="item in timeEnum"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item label="下架时间：" prop="offlineTime">
      <div v-if="props.readOnly">
        {{ruleForm.offlineTime}}
      </div>
      <el-date-picker
          :disabled="ruleForm.isDefault"
          @change="handleEffectiveValue"
          v-else
          v-model="ruleForm.offlineTime"
          type="datetime"
          placeholder="下架时间"
      />
    </el-form-item>
    <el-form-item label="封面Banner图片：" prop="coverImage">
      <div v-if="props.readOnly">
        <el-image
          style="width: 100px; height: 100px"
          :src="ruleForm.coverImage"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="[ruleForm.coverImage]"
          show-progress
          :initial-index="0"
          fit="contain"
      />
      </div>
      <BoxUpload v-else :width="cacheSaleLocationData.width" :height="cacheSaleLocationData.height" ref="boxUploadRef" :ali-oss-path="'ADVERTISEMENT_COVER_IMAGE'" :file-size="5" @progress="loadingValue = true" @success="handlePicSuccess" @remove="handlePicRemove" :limit="1"/>
    </el-form-item>
    <el-form-item label="广告详情页面：">
      <div v-if="props.readOnly" class="ql-editor readonly_box" v-html="ruleForm.details"></div>
      <div v-else>
        <el-tabs
            v-model="advDetailTab"
            type="card"
            class="demo-tabs"
        >
          <el-tab-pane label="中文" name="zh">
            <YTEditor :ali-oss-path="'ADVERTISEMENT_DETAIL_IMAGE'" ref="YTEditorRef" :max-pic-size="3" :maxLength="20000" :reviewTxt="ruleForm.details"></YTEditor>
          </el-tab-pane>
          <el-tab-pane label="English" name="en">
            <YTEditor :ali-oss-path="'ADVERTISEMENT_DETAIL_IMAGE'" ref="YTEditorEnRef" :max-pic-size="3" :maxLength="20000" :reviewTxt="ruleForm.details_en"></YTEditor>
          </el-tab-pane>
        </el-tabs>
        <div class="flex_left"><span class="tips_default">最多上传5张图片，单张图片不超过3MB</span></div>
      </div>
    </el-form-item>
    <el-form-item label="跳转链接：" prop="urlType">
      <div style="text-align: left" v-if="props.readOnly">
        <div v-if="ruleForm.urlType === 'INNER'">内部链接</div>
        <div v-else-if="ruleForm.urlType === 'OUTER'">外部链接</div>
        <div v-else>—</div>
        <el-text type="primary">{{ruleForm.url}}</el-text>
        <div v-if="ruleForm.urlType === 'OUTER'">appId: <el-text type="primary">{{ruleForm.urlAppId}}</el-text></div>
      </div>
      <div v-else>
        <div class="flex_left w-100">
          <el-radio-group v-model="ruleForm.urlType">
            <el-radio :value="'INNER'">内部链接</el-radio>
            <el-radio :value="'OUTER'">外部链接</el-radio>
          </el-radio-group>
        </div>
        <el-input v-if="ruleForm.urlType" style="width: 250px;" v-model="ruleForm.url" placeholder="请输入链接"></el-input>
        <el-input class="mg_l_1" v-if="ruleForm.urlType && ruleForm.urlType === 'OUTER'" style="width: 250px;" v-model="ruleForm.urlAppId" placeholder="请输入小程序AppId"></el-input>
      </div>
    </el-form-item>
    <el-form-item label="意见：" v-if="isAudit" prop="remark">
      <el-input type="textarea" :resize="'none'" :rows="5" maxLength="30" placeholder="请输入意见" v-model="ruleForm.remark" />
    </el-form-item>
    <el-form-item label=" " v-if="!props.readOnly">
      <div>
        <v-row>
          <v-col>
            <v-btn @click="resetForm">取消</v-btn>
          </v-col>
          <v-col>
            <v-btn color="primary" @click="submit">提交</v-btn>
          </v-col>
        </v-row>
      </div>
    </el-form-item>
    <el-form-item label=" " v-if="props.isAudit">
      <div>
        <v-row>
          <v-col>
            <v-btn @click="handleAudit('reject')">驳回</v-btn>
          </v-col>
          <v-col>
            <v-btn color="primary" @click="handleAudit('approved')">通过</v-btn>
          </v-col>
        </v-row>
      </div>
    </el-form-item>
    <div v-if="props.readOnly || props.isEdit">
      <el-divider/>
      <div>
        <div class="step_box" v-for="(item, index) in props.listAdvLog" :key="`advLog${index}`">
          <div class="step_title">
            <div :class="item.state === 'PENDING_REVIEW' ? 'step_title_icon_red' : 'step_title_icon_blue'"></div>
            <div>{{item.reviewerName}}————
              <span v-if="item.state === 'SUBMITTED'">已提交</span>
              <span v-else-if="item.state === 'PENDING_REVIEW'">审批中</span>
              <span v-else-if="item.state === 'APPROVED'">已通过</span>
              <span v-else-if="item.state === 'REJECTED'">已驳回</span>
            </div>
          </div>
          <div class="step_info">
            <div>{{item.crTime}}</div>
            <div v-if="item.remark || item.remark !== ''">意见：{{item.remark}}</div>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<style scoped>
.readonly_box {
  min-width: 600px;
  max-width: 100%;
  min-height: 150px;
  background: #ffffff;
  border-radius: 9px;
  border: 1px solid #796cb4;
  box-sizing: border-box;
  padding: 10px;
}
.step_box {
  flex: 1;
  min-width: 400px;
  font-size: 13px;
  color: #9c9c9c;
  .step_title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .step_title_icon_red {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #e3624a;
      margin-right: 10px;
    }
    .step_title_icon_blue {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #5273f6;
      margin-right: 10px;
    }
  }
  .step_info {
    text-align: left;
    box-sizing: border-box;
    padding-left: 16px;
    border-left: 1px dashed #000;
    margin-left: 8px;
    min-height: 50px;
    margin-bottom: 10px;
  }
}
.step_box:last-child {
  .step_info {
    text-align: left;
    box-sizing: border-box;
    padding-left: 16px;
    border-left: none;
    margin-left: 8px;
    min-height: 50px;
    margin-bottom: 10px;
  }
}
</style>
